import { NAME_SPACE } from './config';
import desktopNav from './DesktopNav.vue';

export default {
    name: NAME_SPACE,
    components: {
        'desktop-nav': desktopNav,
    },
};
